/* ================================================================
   Witterung — Client.

   Die Daten kommen nicht mehr direkt von Open-Meteo, sondern über den
   eigenen Server (/api/wetter/...). Dort wird die Freischaltung je
   Konto geprüft und die Antwort zwischengespeichert; die Verdichtung
   zu Jahrgangs-Kennzahlen passiert ebenfalls dort.

   Die Rückgabewerte sind unverändert — bereits gespeicherte
   Witterungsdaten im Kellerbuch bleiben also gültig.
   ================================================================ */

async function hole(pfad) {
  let antwort;
  try {
    antwort = await fetch(pfad);
  } catch (e) {
    throw new Error("Der Server ist nicht erreichbar.");
  }
  if (antwort.status === 401) throw new Error("Bitte neu anmelden.");
  if (antwort.status === 403) throw new Error("Wetterdaten sind für dieses Konto nicht freigeschaltet.");
  const json = await antwort.json().catch(() => ({}));
  /* Limit bei Open-Meteo: Status und Grenze mitgeben, damit der
     Ladelauf wartet (Minute) oder aufhört (Stunde, Tag). */
  if (antwort.status === 429) {
    const e = new Error(json.fehler || "Open-Meteo-Limit erreicht.");
    e.status = 429;
    e.grenze = json.grenze || null;
    throw e;
  }
  if (!antwort.ok) throw new Error(json.fehler || "Die Wetterdaten konnten nicht geladen werden.");
  return json;
}

function pruefeRegion(region) {
  if (!region || region.lat == null || region.lon == null) {
    throw new Error("Für diese Region fehlen Koordinaten.");
  }
}

/** Witterung der Vegetationsperiode eines Jahrgangs. */
async function ladeWitterung(region, jahr) {
  pruefeRegion(region);
  return hole(`/api/wetter/jahrgang?lat=${encodeURIComponent(region.lat)}`
    + `&lon=${encodeURIComponent(region.lon)}&jahr=${encodeURIComponent(jahr)}`);
}

/** Klimareihe einer Region über alle verfügbaren Archivjahre. */
async function ladeKlimareihe(region) {
  pruefeRegion(region);
  return hole(`/api/wetter/klimareihe?lat=${encodeURIComponent(region.lat)}`
    + `&lon=${encodeURIComponent(region.lon)}`);
}

export { ladeKlimareihe, ladeWitterung };
